import { consoleEvents } from '@pb/utils'

import { CheckoutSuccessAction } from 'features/checkout/constants'
import { postProceedFail } from 'features/checkout/duck/actions'
import { handleProceedError } from 'features/checkout/duck/operations/postProceed/handleProceedError'
import { postConfirmCheckout } from 'features/checkout/requests'
import { completeRazorpayCheckout } from 'features/razorpay/duck/actions'
import { ThunkResult } from 'redux/types'

export const operationConfirmRazorpayCheckout =
  ({ ...razorpayData }): ThunkResult<Promise<void>> =>
  async (dispatch) => {
    try {
      const confirmResponse = await postConfirmCheckout({
        razorpayData,
      })

      if (confirmResponse.successAction === CheckoutSuccessAction.SelfRedirect) {
        window.location.href = confirmResponse.redirectURL
      }
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(completeRazorpayCheckout())
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }

export const operationAbortConfirmRazorpayCheckout =
  (): ThunkResult<Promise<void>> => async (dispatch) => {
    try {
      dispatch(completeRazorpayCheckout())
      await postConfirmCheckout({
        abortPayment: true,
      })
    } catch (error) {
      consoleEvents.error('Failed to confirm checkout', error)
      dispatch(postProceedFail())
      dispatch(handleProceedError(error))
    }
  }
